import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-cinema-dark/95 backdrop-blur-md border-b border-cinema-border'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-cinema-gold font-heading text-2xl font-bold tracking-wider">
              8090<span className="text-white">影视</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-cinema-gold'
                  : 'text-cinema-text hover:text-cinema-gold'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.key}
                to={`/category/${cat.key}`}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.key}`
                    ? 'text-cinema-gold'
                    : 'text-cinema-text hover:text-cinema-gold'
                }`}
              >
                {cat.label}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-cinema-gold'
                  : 'text-cinema-text hover:text-cinema-gold'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索电影..."
                className="w-48 px-4 py-2 pl-9 text-sm bg-cinema-card border border-cinema-border rounded-full text-cinema-text placeholder-cinema-text-dim focus:outline-none focus:border-cinema-gold transition-colors"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-cinema-text-dim text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-cinema-text cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-cinema-dark border-t border-cinema-border animate-fade-in">
          <div className="px-4 py-4 space-y-3">
            <Link
              to="/"
              className={`block text-sm font-medium py-2 cursor-pointer ${
                location.pathname === '/' ? 'text-cinema-gold' : 'text-cinema-text'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.key}
                to={`/category/${cat.key}`}
                className={`block text-sm font-medium py-2 cursor-pointer ${
                  location.pathname === `/category/${cat.key}`
                    ? 'text-cinema-gold'
                    : 'text-cinema-text'
                }`}
              >
                {cat.label}
              </Link>
            ))}
            <Link
              to="/about"
              className={`block text-sm font-medium py-2 cursor-pointer ${
                location.pathname === '/about' ? 'text-cinema-gold' : 'text-cinema-text'
              }`}
            >
              关于我们
            </Link>
            <div className="pt-2">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索电影..."
                  className="w-full px-4 py-2 pl-9 text-sm bg-cinema-card border border-cinema-border rounded-full text-cinema-text placeholder-cinema-text-dim focus:outline-none focus:border-cinema-gold"
                />
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-cinema-text-dim text-sm"></i>
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}